import React from 'react'
import styled from 'styled-components'
import RequestsHotelsCardPipeline from './RequestsHotelsCardPipeline.jsx';

const status = [
    'rh_en_attente',
    'rh_attente_nouveau_devis',
    'rh_en_cours',
    'rh_demande_d_option',
    'rh_sous_option',
    'rh_client_souhaite_reserver',
	'rh_attente_paiement_client',
	'rh_reservee'
];

const Wrapper = styled.div`
	border-radius: 12px;

	.pipeline-container {
		border-radius: 12px;
		display: flex;
		align-items: start;
		padding: 0;
		overflow-x: auto;
		height: 80vh;

		&::-webkit-scrollbar {
			height: .4rem;
		}
	
		&::-webkit-scrollbar-thumb {
			background-color: #004753;
			border-radius: 50px;
			margin: 0 1rem;
		}

		.pipeline-col {
			flex: 0 0 18rem;
			display: flex;
			flex-direction: column;
			height: 100%;
			padding: 0;
			margin: 0;

			.pipeline-col-header {
				height: 60px;
				border-right: 1px solid #fff;
			}
	
			&:first-of-type {
				.pipeline-col-header {
					border-top-left-radius: 12px;
				}
			}

			&:last-of-type {
				margin-right: 0;
				.pipeline-col-header {
					border-top-right-radius: 12px;
					border-right: none;
				}
			}
			
			.pipeline-col-items {
				flex: 1;
				display: flex;
				flex-direction: column;
				align-content: start;
				padding: 0.5rem 0.5rem 0 0.5rem;
				overflow-y: auto;
				border-right: 1px solid #dfdfdf;
			}
			
			.pipeline-col-items::-webkit-scrollbar {
				width: .3rem;
			}
			
			.pipeline-col-items::-webkit-scrollbar-thumb {
				background-color: #004753;
				border-radius: 50px;
			}
		}
	}
`;

export default function RequestsHotelsCard(props){
	const { 
		items
	} = props

	return (
		<Wrapper className="col-12">
			<div className="pipeline-container bg-white">
			{
				status.map((s, i) => 
					<div key={i} className="pipeline-col">
						<div className="pipeline-col-header bg-gc-light-blue-dark px-3 d-flex flex-wrap justify-content-center align-items-center">
							<h3 className="h6 text-center text-gc-dark-blue font-weight-bold m-0" style={{lineHeight: '1rem'}}>
								{('status_key_trad.' + s + '').trad()}
							</h3>
						</div>
						<div className="pipeline-col-items">
							{
								typeof(items[s]) != 'undefined' && 
									items[s].map((e, i) =>
										{
											if(s === e.requests_hotels.status_requests_hotels)
												return	<RequestsHotelsCardPipeline
													key={i}
													id={e.requests_hotels.id}
													img={e.hotels.img}
													title={e.membres.display_name}
													checkin={e.requests_hotels.checkin ?? e.requests.checkin}
													checkout={e.requests_hotels.checkout ?? e.requests.checkout}
													accommodation={e.requests.nb_pax_total > 0 ? true : false}
													hotel={e.hotels.title}
													refRequest={e.requests.id}
													refHotel={e.requests_hotels.ref_hotel}
													refCustomer={e.requests.ref_client}
													requests={e.requests}
													segment={e.segmentations.label}
													lastViews={{
														client: {
															last: e.requests_hotels.vuuser,
															nb: e.requests_hotels.nbvueuser
														},
														hotelier: {
															last: e.requests_hotels.vuhotelier,
															nb: e.requests_hotels.nbvuehotelier
														}
													}}
													customer={e.membres}
													societe={e.requests_societes}
													connectivityInfos={e.connectivity_infos}
												/>
										}
									)
							}										
						</div>
					</div>
				)  
			}
			</div>
		</Wrapper>
	);
}